import type { ISupraLockbox } from '@bb/domain/dist/types';
import axios from 'axios';

export type SupraLock = ISupraLockbox & {
  listing?: {
    _id: string;
    line1: string;
    line2: string;
    availability: string;
  };
};

const getListingSupraLocks = async (listingId: string) => {
  const { data } = await axios.get<SupraLock[]>(
    `/lockbox/supraLockbox/listing/${listingId}`,
  );

  return data;
};

export default getListingSupraLocks;
